// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhg_a bhg_x bhg_j bhg_u bhg_bc bhg_qj bhg_vt"};